export interface PurchaseOrderLineRequirementsSummaryTop {
  productKey: string;
  productDescription: string;
  quantity: number;
  requirementQuantity: number;
  allocated: number;
  issued: number;
}
